import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import CustomerDetails from "./pages/CustomerDetails";
import Interactions from "./pages/Interactions";
import Orders from "./pages/Orders";
import Reports from "./pages/Reports";
import Users from "./pages/Users";
import Salespersons from "./pages/Salespersons";
import Layout from "./components/Layout";
import SalespersonDetails from "./pages/SalespersonDetails";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* Redirect /register to /login — registration is admin-only */}
            <Route path="/register" element={<Navigate to="/login" replace />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard"          element={<Dashboard />} />
              <Route path="customers"          element={<Customers />} />
              <Route path="customers/:id"      element={<CustomerDetails />} />
              <Route path="interactions"       element={<Interactions />} />
              <Route path="orders"             element={<Orders />} />
              <Route path="reports"            element={<Reports />} />
              <Route path="users"              element={<Users />} />
              <Route path="salespersons"       element={<Salespersons />} />
              <Route path="salespersons/:id"   element={<SalespersonDetails />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
